export const labelledById = (id) => `modal-${id}-title`;
//# sourceMappingURL=utils.js.map